class FreeKitProgress {
  constructor() {
    this.country = 'OM';
    this.freeKitThreshold = Number(window.theme?.freeKitThreshold || 30);
    this.currencyEnglish = 'OMR';
    this.currencyArabic = '\u0631.\u0639';
    this.init();
  }

  get isArabic() {
    const routeRoot = (window.Shopify?.routes?.root || '').toLowerCase();
    const path = window.location.pathname.toLowerCase();
    const arabicDefaultCountries = ['BH', 'SA', 'KW', 'QA', 'OM'];
    const englishDefaultCountries = ['UAE', 'AE'];
    const hasEnglishPath = path === '/en' || path.startsWith('/en/') || routeRoot === '/en/';
    const hasArabicPath = path === '/ar' || path.startsWith('/ar/') || routeRoot === '/ar/';

    if (arabicDefaultCountries.includes(this.country)) {
      return !hasEnglishPath;
    }

    if (englishDefaultCountries.includes(this.country)) {
      return hasArabicPath;
    }

    return (
      (window.Shopify && Shopify.locale && Shopify.locale.toLowerCase().startsWith('ar')) ||
      (document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('ar')) ||
      document.documentElement.dir === 'rtl' ||
      document.body.dir === 'rtl' ||
      hasArabicPath
    );
  }

  getCopy() {
    if (this.isArabic) {
      return {
        successMessage: '\u0644\u0642\u062f \u062d\u0635\u0644\u062a \u0639\u0644\u0649 \u0645\u062c\u0645\u0648\u0639\u0629 \u0645\u062c\u0627\u0646\u064a\u0629!',
        progressMessage: '\u0623\u0636\u0641 [amount] \u0644\u062a\u062d\u0635\u0644 \u0639\u0644\u0649 \u0645\u062c\u0645\u0648\u0639\u0629 \u0645\u062c\u0627\u0646\u064a\u0629!',
        kitName: '\u0645\u062c\u0645\u0648\u0639\u0629 \u0639\u064a\u0646\u0627\u062a \u0641\u0627\u062e\u0631\u0629',
        kitDescription: '\u0645\u062c\u0645\u0648\u0639\u0629 \u0645\u062e\u062a\u0627\u0631\u0629 \u0645\u0646 \u0623\u0631\u0642\u0649 \u0639\u0637\u0648\u0631\u0646\u0627'
      };
    }

    return {
      successMessage: window.theme?.kitSuccessMessage || "Congratulations! You've qualified for a FREE Kit!",
      progressMessage: window.theme?.kitProgressMessage || 'Add [amount] more to get a FREE Kit!',
      kitName: window.theme?.kitName || 'Luxury Sample Kit',
      kitDescription: window.theme?.kitDescription || 'A curated collection of our finest fragrances'
    };
  }

  init() {
    this.updateProgress();
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added', 'product:added'].forEach((eventName) => {
      document.addEventListener(eventName, () => this.scheduleUpdate());
    });
  }

  scheduleUpdate() {
    window.setTimeout(() => this.updateProgress(), 100);
    window.setTimeout(() => this.updateProgress(), 700);
  }

  async updateProgress() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      const cart = await response.json();
      const cartTotal = cart.total_price / 100;

      const progressBarElement = document.getElementById('kit-progress');
      const messageElement = document.getElementById('kit-progress-message');
      const kitContainer = document.querySelector('.free-kit-progress');
      const kitDetails = document.getElementById('kit-details');
      const kitName = document.querySelector('.kit-name');
      const kitDescription = document.querySelector('.kit-description');

      if (!progressBarElement || !messageElement || !kitContainer) return;

      const copy = this.getCopy();
      if (kitName) kitName.textContent = copy.kitName;
      if (kitDescription) kitDescription.textContent = copy.kitDescription;

      const progress = Math.min((cartTotal / this.freeKitThreshold) * 100, 100);
      const remaining = Math.max(this.freeKitThreshold - cartTotal, 0);
      const achieved = cartTotal >= this.freeKitThreshold;

      progressBarElement.style.width = progress + '%';
      messageElement.textContent = achieved
        ? copy.successMessage
        : copy.progressMessage.replace('[amount]', this.formatMoney(remaining));
      messageElement.dir = this.isArabic ? 'rtl' : 'ltr';
      kitContainer.dir = this.isArabic ? 'rtl' : 'ltr';
      kitContainer.classList.toggle('free-kit-achieved', achieved);

      if (kitDetails) {
        kitDetails.classList.toggle('show', achieved);
      }
    } catch (error) {
      console.error('Error updating free kit progress:', error);
    }
  }

  formatMoney(amount) {
    const formatted = amount.toLocaleString(this.isArabic ? 'ar' : 'en', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    });

    return this.isArabic ? formatted + ' ' + this.currencyArabic : this.currencyEnglish + ' ' + formatted;
  }
}

window.junaidFreeKitProgress = window.junaidFreeKitProgress || new FreeKitProgress();
document.addEventListener('DOMContentLoaded', () => {
  window.junaidFreeKitProgress = window.junaidFreeKitProgress || new FreeKitProgress();
  window.junaidFreeKitProgress.scheduleUpdate();
});